import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TitleH2 from '../components/Title/TitleH2';
import ivclass from '../Modules/IVClass';
import SliderTray from '../components/slider/SliderTray';
import BlogPostCard from '../components/blog-card/BlogCard';
function DiscoverBlogs(props) {
    const { blogs, blogHeading, platform, browser } = props;
    return (_jsx("div", { className: ivclass('iv-bg-grey-5', 'iv-py-100', 'iv-mt-200 md:iv-mt-150 sm:iv-mt-100'), children: _jsxs("div", { className: ivclass('iv-container iv-mx-auto', ''), children: [_jsx("div", { className: ivclass('iv-grid', 'iv-col-span-12', 'xl:iv-col-start-1 lg:iv-col-start-1', 'xl:iv-px-15 lg:iv-px-20', 'iv-text-center'), children: _jsx(TitleH2, { heading: blogHeading.title }) }), _jsx("div", { className: ivclass('iv-mt-75 sm:iv-mt-30 iv-px-80 md:iv-px-40 sm:iv-px-20 iv-overflow-x-hidden'), children: blogs && (_jsx(SliderTray, { platform: platform, sliderWrapperCls: ivclass('lg:iv-mr-20', 'md:iv-mr-15', 'sm:iv-mr-20'), children: blogs
                            ?.map(data => {
                            return {
                                id: data.id,
                                title: data.Title,
                                featureImage: data.FeatureImage,
                                slug: data.Slug,
                                trending: data.trending,
                                category: data.categories_v_2,
                                platform: data.platform,
                                profession: data.profession,
                            };
                        })
                            .map((post, index) => (_jsx("div", { className: ivclass('iv-relative', 'iv-mr-40 md:iv-mr-30', index === 0 && 'iv-ml-20'), children: _jsx(BlogPostCard, { ...post, devicePlatform: platform, lazyLoadImg: true, browser: browser, backgroundColorClass: 'iv-bg-grey-0' }) }, post.id))) })) })] }) }));
}
export default DiscoverBlogs;
